module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-image"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "171",
      "src": "images/f000v-01.jpg",
      "width": "220"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "chap"
  }, [_c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('strong', [_vm._v("I")]), _vm._v("    The Medieval Ethno-Religious Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('strong', [_vm._v("II")]), _vm._v("    Kievan "), _c('em', [_vm._v("Rus")]), _vm._v("’ and the Steppe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("III")]), _vm._v("    The Mongol Empire and the Golden Horde")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV")]), _vm._v("    The Mongol Administration of Russia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V")]), _vm._v("    The Mongol Role in Russian Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI")]), _vm._v("    The Russian “Theory” of Mongol Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VII")]), _vm._v("    Economic and Demographic Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VIII")]), _vm._v("    The Mongols and the Muscovite Autocracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IX")]), _vm._v("    The Mongols and Russian Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("X")]), _vm._v("    Cultural Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("XI")]), _vm._v("    Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0